import React from 'react';
import { HeartIcon } from 'lucide-react';
import { Fade } from '../deck/Slide';
import { FloatingHearts } from '../deck/FloatingHearts';
const portfolios = ['Roche', 'GSK', '3M Health'];
const snakkerOffer = ['A dedicated LEO team', 'Full funnel activation', 'Country overlap and shared learnings', 'Cross-brand parallel campaigns', 'Spin-offs for upcoming events', 'Medical Affairs alongside brand', 'Cost efficiencies passed on to you'];
const leoNeeds = ['Central visibility', 'One compliance standard', 'Comparable campaign impact', 'Country activation', 'Falling cost to serve', 'Technical innovation', '??????'];
export function PartnershipSlide() {
  return <section className="relative flex h-full w-full flex-col overflow-hidden bg-[var(--brand-green)] p-[clamp(1.4rem,3vw,3rem)] font-sans text-white" data-id="element-134" data-mp="39pfrfgjo3ico">
      <div className="absolute left-0 right-0 top-0 h-1 bg-[var(--brand-green-lighter)]" data-id="element-135" data-mp="3ol40bizxktmw" />
      <FloatingHearts data-id="element-136" data-mp="3jpyh4rxwxt2i" />

      <div className="relative z-10 mb-[clamp(0.5rem,1vw,1rem)] flex flex-shrink-0 items-center gap-4" data-id="element-137" data-mp="3jmaodv0alaou">
        <HeartIcon className="h-5 w-5 text-[var(--brand-green-lighter)]" fill="currentColor" aria-hidden="true" data-id="element-138" data-mp="282hhums61exg" />
        <p className="text-[clamp(0.72rem,1.05vw,0.95rem)] font-semibold uppercase tracking-[0.25em] text-[var(--brand-green-lighter)]" data-id="element-139" data-mp="2c3b1h3yks7kj">
          Setting the scene
        </p>
      </div>

      <div className="relative z-10 grid min-h-0 flex-1 grid-cols-[0.95fr_1.05fr] gap-[clamp(1.25rem,3vw,3rem)]" data-id="element-140" data-mp="2m17anq7ycsg0">
        <div className="flex min-h-0 flex-col justify-between" data-id="element-141" data-mp="2qzsgq69vy6cd">
          <h2 className="text-[clamp(1.7rem,3.3vw,3.1rem)] font-bold leading-[1.02]" data-id="element-142" data-mp="2vrtn5bkdh2uh">
            Brands need love.
            <br data-id="element-143" data-mp="2zsm0afwd7rw1" />
            <span className="text-[var(--brand-green-lighter)]" data-id="element-144" data-mp="2zt5i7wm0mga2">
              Attention makes them thrive.
            </span>
          </h2>

          <Fade delay={0.15} data-id="element-145" data-mp="39rl8jxd7xlii">
            <p className="max-w-[30ch] text-[clamp(1.05rem,1.75vw,1.75rem)] font-medium leading-snug text-white/85" data-id="element-146" data-mp="39swcpyaksva5">
              Today that attention is given campaign by campaign, market by
              market. Every engagement starts from scratch, and the learning
              stays where it happened.
            </p>
          </Fade>

          <Fade delay={0.28} data-id="element-147" data-mp="1jhhpdg4stud6">
            <div className="border-t border-white/20 pt-[clamp(0.6rem,1.1vw,1.1rem)]" data-id="element-148" data-mp="1eoy9udmjwp5q">
              <p className="text-[clamp(0.66rem,0.88vw,0.86rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand-green-lighter)]" data-id="element-149" data-mp="1sg322unlaf61">
                Brand portfolios we plan our teams around
              </p>
              <div className="mt-[clamp(0.5rem,0.9vw,0.9rem)] flex flex-wrap items-center gap-[clamp(0.5rem,1vw,1rem)]" data-id="element-150" data-mp="22esmau2ykbpg">
                {portfolios.map(name => <span key={name} className="text-[clamp(1.2rem,2.3vw,2.3rem)] font-bold leading-none tracking-tight text-white" data-id="element-151" data-mp="1xdd0v0wvc36j">
                    {name}
                  </span>)}
                <span className="rounded-xl border-2 border-dashed border-white/40 px-[clamp(0.6rem,1.1vw,1.1rem)] py-[clamp(0.3rem,0.6vw,0.6rem)]" data-id="element-152" data-mp="2eptci64tj1rg">
                  <span className="text-[clamp(1.2rem,2.3vw,2.3rem)] font-bold leading-none tracking-tight text-white/55" data-id="element-153" data-mp="24yoz3ausjoyq">
                    LEO Pharma
                  </span>
                </span>
              </div>
            </div>
          </Fade>
        </div>

        <div className="flex min-h-0 flex-col gap-[clamp(0.6rem,1.1vw,1.1rem)]" data-id="element-154" data-mp="1vwpg4d07uat5">
          <Fade delay={0.22} className="flex flex-1" data-id="element-155" data-mp="20xvbkil9gc6d">
            <div className="flex flex-1 flex-col justify-center rounded-2xl border border-white/15 bg-white/[0.07] p-[clamp(0.9rem,1.6vw,1.6rem)] backdrop-blur-md" data-id="element-156" data-mp="1lzuma7ew0yl7">
              <p className="text-[clamp(1.15rem,1.7vw,1.7rem)] font-bold leading-tight text-[var(--brand-green-lighter)]" data-id="element-157" data-mp="1qz629e7fk01q">
                What Snakker attention brings
              </p>
              <p className="mt-[clamp(0.35rem,0.7vw,0.7rem)] text-[clamp(0.95rem,1.5vw,1.5rem)] font-semibold leading-snug" data-id="element-158" data-mp="3lcf5io9dupbj">
                A standing team planned around LEO, not assembled per campaign.
              </p>
              <div className="mt-[clamp(0.5rem,0.9vw,0.9rem)] flex flex-wrap gap-[clamp(0.3rem,0.5vw,0.5rem)]" data-id="element-159" data-mp="1h6zt642ghfre">
                {snakkerOffer.map(item => <span key={item} className="rounded-full border border-white/20 bg-white/[0.1] px-[clamp(0.6rem,1vw,1rem)] py-[clamp(0.25rem,0.45vw,0.45rem)] text-[clamp(0.78rem,1.02vw,1.02rem)] font-semibold text-white" data-id="element-160" data-mp="17a4spfmmh5ah">
                    {item}
                  </span>)}
              </div>
            </div>
          </Fade>

          <Fade delay={0.34} className="flex flex-1" data-id="element-161" data-mp="olq04nwnpj7k">
            <div className="flex flex-1 flex-col justify-center rounded-2xl bg-white p-[clamp(0.9rem,1.6vw,1.6rem)] shadow-sm" data-id="element-162" data-mp="jl2eyiv3zwl9">
              <p className="text-[clamp(1.15rem,1.7vw,1.7rem)] font-bold leading-tight text-[var(--brand-green)]" data-id="element-163" data-mp="enaa6o9d8fzn">
                What LEO needs as a brand love partner
              </p>
              <p className="mt-[clamp(0.35rem,0.7vw,0.7rem)] text-[clamp(0.9rem,1.4vw,1.4rem)] font-semibold leading-snug text-[var(--fg)]" data-id="element-164" data-mp="9glzvrpgejii">
                One standard across every brand and market, at a falling cost to
                serve, with measurable impact centrally visible.
              </p>
              <div className="mt-[clamp(0.5rem,0.9vw,0.9rem)] flex flex-wrap gap-[clamp(0.3rem,0.5vw,0.5rem)]" data-id="element-165" data-mp="3hy01l5k7m1kr">
                {leoNeeds.map(item => <span key={item} className={item === '??????' ? 'rounded-full border-2 border-dashed border-[var(--brand-green-light)] px-[clamp(0.6rem,1vw,1rem)] py-[clamp(0.25rem,0.45vw,0.45rem)] text-[clamp(0.78rem,1.02vw,1.02rem)] font-semibold tracking-[0.15em] text-[var(--brand-green-light)]' : 'rounded-full bg-[var(--surface)] px-[clamp(0.6rem,1vw,1rem)] py-[clamp(0.25rem,0.45vw,0.45rem)] text-[clamp(0.78rem,1.02vw,1.02rem)] font-semibold text-[var(--brand-green)]'} data-id="element-166" data-mp="3mtyqqvdd3nm8">
                    {item}
                  </span>)}
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>;
}